// import { get } from 'lodash';

export default {
  getActiveRequests: (state) => state.activeRequests,
};
